export default "__VITE_ASSET__DRG7JnbH__"